import { TableCell, TableRow } from '@mui/material';
import { flexRender, Row } from '@tanstack/react-table';

import { getPinnedSx } from './pinnedSx';

interface TableBodyRowProps<T> {
  row: Row<T>;
  isLast: boolean;
  lastLeftColId: string | undefined;
  firstRightColId: string | undefined;
  onRowClick?: (row: Row<T>) => void;
}

const TableBodyRow = <T,>({
  row,
  isLast,
  lastLeftColId,
  firstRightColId,
  onRowClick,
}: TableBodyRowProps<T>) => {
  return (
    <TableRow
      onClick={
        onRowClick
          ? () => {
              onRowClick(row);
            }
          : undefined
      }
      sx={[
        onRowClick
          ? {
              cursor: 'pointer',
              '&:hover td': { bgcolor: 'grey.100' },
            }
          : {},
      ]}
    >
      {row.getVisibleCells().map((cell) => (
        <TableCell
          key={cell.id}
          {...(cell.column.getIsPinned() ? { 'data-pinned': true } : {})}
          sx={{
            borderColor: 'divider',
            py: 2,
            width: `var(--col-live-size-${cell.column.id}, ${String(cell.column.getSize())}px)`,
            minWidth: `var(--col-live-size-${cell.column.id}, ${String(cell.column.getSize())}px)`,
            maxWidth: `var(--col-live-size-${cell.column.id}, ${String(cell.column.getSize())}px)`,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            border: isLast ? 0 : '',
            ...getPinnedSx(
              cell.column,
              false,
              cell.column.id === lastLeftColId,
              cell.column.id === firstRightColId
            ),
          }}
        >
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </TableCell>
      ))}
    </TableRow>
  );
};

export default TableBodyRow;
